import type { CSSProperties } from "react";

import {
    dinoAssistantStateAssets
} from "../../assets/dino-assistant/dinoAssistantAssets.js";
import type {
    DinoAssistantState
} from "../../assets/dino-assistant/dinoAssistantAssets.js";

type DinoAvatarMotion =
    | "still"
    | "float"
    | "celebrate";

interface DinoAvatarProps {
    className?: string;
    interactive?: boolean;
    label?: string;
    motion?: DinoAvatarMotion;
    size?: number;
    state?: DinoAssistantState;
}

interface AvatarStyle extends CSSProperties {
    "--dino-avatar-size": string;
}

/** The single visual primitive for Dino outside the assistant panel. */
function DinoAvatar({
    className = "",
    interactive = false,
    label,
    motion = "still",
    size = 34,
    state = "idle"
}: DinoAvatarProps) {
    const style: AvatarStyle = {
        "--dino-avatar-size": `${size}px`
    };

    return (
        <span
            className={`dino-avatar ${className}`}
            style={style}
            role={label ? "img" : undefined}
            aria-label={label}
            aria-hidden={label ? undefined : "true"}
            data-dino-avatar="true"
            data-dino-state={state}
            data-dino-interactive={interactive ? "true" : undefined}
            data-dino-motion={motion}
        >
            <img
                className="dino-avatar__image"
                src={dinoAssistantStateAssets[state]}
                alt=""
                aria-hidden="true"
                draggable={false}
            />
        </span>
    );
}

export { DinoAvatar };
export type { DinoAvatarMotion, DinoAvatarProps };
